webpackJsonp([121],{

/***/ 2500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NeuCardGeneral_vue__ = __webpack_require__(3168);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc7b31f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NeuCardGeneral_vue__ = __webpack_require__(3676);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3674)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc7b31f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NeuCardGeneral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc7b31f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NeuCardGeneral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/ui/NeuCardGeneral.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fc7b31f2", Component.options)
  } else {
    hotAPI.reload("data-v-fc7b31f2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_opensalud_pacientes_json__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_opensalud_pacientes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_opensalud_pacientes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_opensalud_pacientes_json__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_opensalud_pacientes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_opensalud_pacientes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_colours__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'neu-card-general',
  i18n: {
    reviews: {
      es: __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_opensalud_pacientes_json___default.a,
      en: __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_opensalud_pacientes_json___default.a,
      mx: __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_opensalud_pacientes_json___default.a
    }
  },
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: false,
      default: null
    },
    subtitle: {
      type: String,
      required: false
    },
    subtitleLines: Number,
    titleLines: Number,
    iconColor: {
      type: String,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_2__constants_colours__["c" /* BLUE_COLOUR */]
    }
  },
  computed: {
    go: function go() {
      this.$router.push(this.link);
    },

    /*     go360 () {
          const url = window.location.hostname.split('.')
          const envSubdomain = url[0].includes('desarrollo-360') ? 'desarrollo-' : url[0].includes('pruebas-360') ? 'pruebas-' : url[0].includes('360') ? '' : url[0].includes('localhost') ? '' : ''
          location.href = `https://${envSubdomain}360.opensalud.es`
        },
        goPat () {
          const url = window.location.hostname.split('.')
          const envSubdomain = url[0].includes('desarrollo') ? 'desarrollo.opensalud.es' : url[0].includes('pruebas') ? 'pruebas.opensalud.es' : url[0].includes('localhost') ? 'localhost:8080' : ''
          location.href = `https://${envSubdomain}/pacientes`
        },
        goProf () {
          const url = window.location.hostname.split('.')
          const envSubdomain = url[0].includes('desarrollo') ? 'desarrollo.opensalud.es' : url[0].includes('pruebas') ? 'pruebas.opensalud.es' : url[0].includes('localhost') ? 'localhost:8080' : ''
          location.href = `https://${envSubdomain}/profesionales`
        }, */
    paddedTitle: function paddedTitle() {
      return this.titleLines ? '' + this.title + '<br>'.repeat(this.titleLines) : this.title;
    },
    paddedSubtitle: function paddedSubtitle() {
      return this.subtitleLines ? '' + '<br>'.repeat(this.titleLines) + this.subtitle + '&ensp;' : this.subtitle + '&ensp;' + '&ensp;';
    }
  }
});

/***/ }),

/***/ 3674:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3004eaac", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fc7b31f2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NeuCardGeneral.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fc7b31f2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NeuCardGeneral.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3675:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-fc7b31f2]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-fc7b31f2],.slide-down-leave-active[data-v-fc7b31f2]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-fc7b31f2],.slide-down-leave-to[data-v-fc7b31f2]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-fc7b31f2],.slide-fade-left-leave-active[data-v-fc7b31f2]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-fc7b31f2],.slide-fade-left-leave-to[data-v-fc7b31f2]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-fc7b31f2]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-fc7b31f2],.fade-leave-to[data-v-fc7b31f2]{opacity:0\n}\n.img-icon[data-v-fc7b31f2]{margin:auto;-o-object-fit:cover;object-fit:cover\n}\n.img-icon.vertical[data-v-fc7b31f2]{height:150px\n}\n@media only screen and (max-width: 575px){\n.img-icon.vertical[data-v-fc7b31f2]{height:150px\n}\n}\n.img-icon[data-v-fc7b31f2]:not(.vertical){width:100px\n}\n@media only screen and (max-width: 575px){\n.img-icon[data-v-fc7b31f2]:not(.vertical){width:150px\n}\n}\n.neu-card-general-ctn[data-v-fc7b31f2]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transition-duration:1s;transition-duration:1s\n}\n@media only screen and (max-width: 575px){\n.neu-card-general-ctn[data-v-fc7b31f2]{padding-top:3rem !important\n}\n}\n.neu-card-general-ctn .neu-card-general[data-v-fc7b31f2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transition-duration:1s;transition-duration:1s;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee;border-radius:23px\n}\n.neu-card-general-ctn .neu-card-general .icon-width-prof[data-v-fc7b31f2]{width:7rem;display:inline-block;margin-block-end:0rem;-webkit-margin-after:1rem\n}\n@media only screen and (max-width: 575px){\n.neu-card-general-ctn .neu-card-general .icon-width-prof[data-v-fc7b31f2]{width:5rem\n}\n}\n.neu-card-general-ctn .neu-card-general .icon-width-logo[data-v-fc7b31f2]{width:15rem;display:inline-block;margin-block-end:5rem;-webkit-margin-after:4rem;-webkit-margin-before:1rem\n}\n.neu-card-general-ctn .neu-card-general .div[data-v-fc7b31f2]{padding:0.5rem\n}\n.neu-card-general-ctn .neu-card-general img[data-v-fc7b31f2]{width:11rem;height:11rem;-webkit-transition-property:none;transition-property:none\n}\n.neu-card-general-ctn .neu-card-general .subtitle-general[data-v-fc7b31f2]{text-align:center;width:90%\n}\n.neu-card-general-ctn .neu-card-general .subtitle-general p[data-v-fc7b31f2]{color:#3238C4\n}\n.neu-card-general-ctn .neu-card-general .subtitle-general p[data-v-fc7b31f2]{font-weight:bold;text-align:center;white-space:normal\n}\n@media only screen and (max-width: 575px){\n.neu-card-general-ctn .neu-card-general .subtitle-general p[data-v-fc7b31f2]{width:100%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-general-ctn .neu-card-general .subtitle-general p[data-v-fc7b31f2]{font-size:1.5rem\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 3676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "neu-card-general-ctn",
      on: {
        click: function($event) {
          return _vm.go()
        }
      }
    },
    [
      _c("div", { staticClass: "neu-card-general btn-min-height" }, [
        _c(
          "div",
          [
            _vm.src ===
            "/static-appopensalud/img/logos/opensalud360_healthierlives_color.svg"
              ? _c("base-icon", {
                  staticClass: "vertical icon-width-logo",
                  attrs: {
                    src: _vm.src,
                    blue: "",
                    fullWidth: "",
                    shadow: "",
                    color: _vm.iconColor
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.src !=
              "/static-appopensalud/img/logos/healthierlives_color.svg" &&
            _vm.src !=
              "/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png" &&
            _vm.src !=
              "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
              ? _c("base-icon", {
                  staticClass: "vertical icon-width-prof",
                  attrs: {
                    src: _vm.src,
                    blue: "",
                    fullWidth: "",
                    shadow: "",
                    color: _vm.iconColor
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.src ==
            "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
              ? _c("img", {
                  staticClass: "vertical icon-width-prof img-icon",
                  attrs: {
                    src:
                      "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "subtitle-general mx-auto" },
          [
            _vm.link === null
              ? _c("p", { domProps: { innerHTML: _vm._s(_vm.paddedTitle) } })
              : _vm._e(),
            _vm._v(" "),
            _vm.link === "360"
              ? _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.paddedTitle) },
                  on: {
                    click: function($event) {
                      return _vm.go360()
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.link !== null && _vm.link !== "360"
              ? _c("router-link", { attrs: { to: _vm.link, tag: "a" } }, [
                  _c("p", { domProps: { innerHTML: _vm._s(_vm.paddedTitle) } })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.subtitle != undefined
              ? _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.paddedSubtitle) }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc7b31f2", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/121.82024014515deefe6721.js